import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SpinnerStatus } from '../_models/SpinnerStatus';
@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private count = 0;
  private spinner$ = new BehaviorSubject<number>(null);

  getSpinnerObservable$(): Observable<number> {
    return this.spinner$.asObservable();
  }

  requestStarted(): void {
    if (++this.count === 1) {
      this.spinner$.next(SpinnerStatus.START);
    }
  }

  requestStopped(): void {
    if (this.count === 0 || --this.count === 0) {
      this.spinner$.next(SpinnerStatus.STOP);
    }
  }

  resetSpinner(): void {
    this.count = 0;
    this.spinner$.next(SpinnerStatus.STOP);
  }
}
